interface UrlParam {
  [key: string]: string;
}

export function getQueryString(name: string, url?: string): string {
  // 推荐使用useUrlSearchParams doc: https://vueuse.org/core/useurlsearchparams/#useurlsearchparams
  let newUrl = url;
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  if (newUrl?.startsWith('//')) {
    newUrl = `https:${newUrl}`;
  }
  const search = newUrl && newUrl !== 'null' ? new URL(newUrl)?.search : window.location.search;
  const r = search.substring(1).match(reg);
  if (r !== null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}

export function replaceUrlQuery(url: string, param: UrlParam, fullPath?: boolean): string {
  const urlObj = new URL(url);
  const { searchParams } = urlObj;
  Object.keys(param).forEach((key) => {
    searchParams.set(key, param[key]);
  });
  urlObj.search = searchParams.toString();
  return fullPath ? `${urlObj.pathname}${urlObj.search}` : urlObj.toString();
}

export const paramsConnectUrl = (param: UrlParam, url: string) => replaceUrlQuery(url, param);

export function getSearchParams(url: string = document.location.href) {
  return new URL(url).searchParams;
}

/*
 * 有key值就返回value，没有则返回整个query对象
 */
export function getUrlQuery(key?: string, url?: string) {
  const params = getSearchParams(url);
  const map: Record<string, string> = {};
  params.forEach((value, key) => {
    map[key] = value;
  });
  return key && key in map ? map[key] : map;
}

export function setQuery(param: Record<string, string>, search?: string) {
  const searchParams = search ? new URLSearchParams(search) : getSearchParams();
  Object.keys(param).forEach((key) => {
    searchParams.set(key, param[key]);
  });
  return searchParams.toString();
}

export function isUrl(string: string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}
